import {
  EdgeProps as FlowEdgeProps,
  NodeProps as FlowNodeProps,
} from '@xyflow/react';
import { GraphEdge, GraphNode } from '@morph-mapper/node-logic';
import { Edge } from './edge';
import { GenericGraphNodeFlow } from './graph-node';
import { TerminalGraphNodeFlow } from './terminal-node';
import { RFGraphNode } from '../organisms/graph-view/utils';

export * from './header';
export * from './graph-node';
export * from './graph-node-output';
export * from './terminal-node';
export * from './reference-select';
export * from './graph-error-boundary';
export * from './footer';
export * from './option-field';
export * from './derivation-accordion';
export * from './output-value';
export * from './panel-tabs-layout';
export * from './template-output';

/**
 * Node and edge registry, defines all available visualisations for elements in the graph.
 */

interface NodeRenderer {
  (props: FlowNodeProps<RFGraphNode>): React.ReactNode;
}

interface NodeCreator {
  (): NodeRenderer;
}

export const Nodes: Record<GraphNode, NodeCreator> = {
  [GraphNode.Generic]: () => GenericGraphNodeFlow,
  [GraphNode.Terminal]: () => TerminalGraphNodeFlow,
};

export const Edges: Record<
  GraphEdge,
  () => (props: FlowEdgeProps) => React.ReactNode
> = {
  [GraphEdge.Default]: () => Edge,
};
